interface ComputerFocusingPersonSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerFocusingPersonSVG = ({
  color,
  style,
}: ComputerFocusingPersonSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="51"
    viewBox="0 0 45 51"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19467)">
      <path
        d="M40.7222 0.586914H4.28816C2.52784 0.586914 1.10083 2.01393 1.10083 3.77424V29.1785C1.10083 30.9388 2.52784 32.3658 4.28816 32.3658H40.7222C42.4825 32.3658 43.9095 30.9388 43.9095 29.1785V3.77424C43.9095 2.01393 42.4825 0.586914 40.7222 0.586914Z"
        stroke={color}
        strokeWidth="1.04846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5854 32.3662L9.63525 37.2835H22.4999H35.3645L33.4144 32.3662"
        stroke={color}
        strokeWidth="1.04846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4915 41.0156L44.2136 47.7363C44.7692 48.7428 44.0458 49.9905 42.8925 49.9905H2.10732C0.954014 49.9905 0.220091 48.7533 0.786261 47.7363L4.5083 41.0156H40.502H40.4915Z"
        stroke={color}
        strokeWidth="1.04846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5825 13.4629C25.5825 13.4629 28.6335 15.1195 29.8288 16.0736C30.1119 16.3042 30.353 16.5768 30.5417 16.8809C30.8982 17.4575 31.066 18.1285 31.066 18.7996V21.7457"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.4175 13.4629C19.4175 13.4629 16.3665 15.1195 15.1713 16.0736C14.8882 16.3042 14.647 16.5768 14.4583 16.8809C14.1018 17.4575 13.9341 18.1285 13.9341 18.7996V21.7457H31.0555"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.5001 15.0668C24.88 15.0668 26.8093 12.6681 26.8093 9.70921C26.8093 6.75026 24.88 4.35156 22.5001 4.35156C20.1202 4.35156 18.1909 6.75026 18.1909 9.70921C18.1909 12.6681 20.1202 15.0668 22.5001 15.0668Z"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.0659 20.7607V21.7463H30.0698H31.0659V20.7607Z"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.2024 4.3623H35.8261V8.98602"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.7978 28.5932H9.17407V23.959"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M35.8261 23.959V28.5932H31.2024"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.17407 8.98602V4.3623H13.7978"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M35.8259 12.9805V20.6238"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.17407 12.9805V20.6238"
        stroke={color}
        strokeWidth="1.04846"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.7357 24.168H18.2642"
        stroke={color}
        strokeWidth="1.04846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6598 26.4111H20.3401"
        stroke={color}
        strokeWidth="1.04846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.234 28.4775H21.7661"
        stroke={color}
        strokeWidth="1.04846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19467">
        <rect width="45" height="50.5673" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerFocusingPersonSVG;
